import React, { useState } from 'react'
import { ruleNames } from 'src/editor/diagnostics/consts'
import { DiagnosticFinding } from '../types'
import { FindingRow } from './finding-row'

interface FindingGroupProps {
  ruleId: string
  findings: DiagnosticFinding[]
}

export const FindingGroup = ({ ruleId, findings }: FindingGroupProps) => {
  const [isExpanded, setIsExpanded] = useState(true)
  const groupName = ruleNames[ruleId] || ruleId

  return (
    <div>
      <button
        type="button"
        className="flex w-full cursor-pointer items-center gap-1.5 border-gray-200 border-b border-none bg-gray-50 px-3 py-1.5 text-left"
        onClick={() => setIsExpanded(prev => !prev)}
      >
        <span className="text-[11px] text-gray-400">
          {isExpanded ? '▾' : '▸'}
        </span>
        <span className="font-semibold text-gray-600 text-xs">{groupName}</span>
        <span className="text-gray-400 text-xs">({findings.length})</span>
      </button>
      {isExpanded &&
        findings.map((finding, index) => (
          <FindingRow
            key={`${finding.entityId}-${finding.ruleId}-${index}`}
            finding={finding}
          />
        ))}
    </div>
  )
}
